import React, { Component } from 'react';
import './MerchantManagement.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getIsUserAnAdmin } from '../UserData/userDataEntity';
import Merchants from './Merchants/Merchants';
import { getIsLoading as getIsUserLoading } from '../Self/selfEntity';

export class MerchantManagement extends Component {
    static propTypes = {
        isAdmin: PropTypes.bool,
        isUserLoading: PropTypes.bool
    };

    render() {
        if (!this.props.isAdmin && !this.props.isUserLoading) {
            return (<div className="emvio-merchant-management">
                Insufficient access rights to manage merchant accounts.
            </div>);
        }

        return (<div className="emvio-merchant-management">
            <Merchants />
        </div>);
    }
}

function mapStateToProps(state) {
    return {
        isAdmin: getIsUserAnAdmin(state),
        isUserLoading: getIsUserLoading(state)
    };
}

export default connect(mapStateToProps)(MerchantManagement);
